import React from "react";

const Button = ({
    children,
    onClick,
    disabled = false,
    variant = "default",
    className = "",
    ...rest
}) => {
    const baseStyles =
        "px-3 py-2.5 sm:px-4 sm:py-3 text-sm sm:text-base font-semibold rounded-lg transition duration-150 ease-in-out h-[44px] sm:h-[48px]";
    const variants = {
        default: `bg-grey-700 hover:bg-[#B84141] text-white cursor-pointer ${disabled ? "!bg-grey-300 text-grey-600 cursor-not-allowed" : ""
            }`,
        transparent: `bg-transparent border border-grey-300 text-grey-900 ${disabled ? "!opacity-50 cursor-not-allowed" : "hover:bg-grey-100"
            }`,
        error: `bg-error-100 text-error-500 border border-error-500 ${disabled ? "!opacity-50 cursor-not-allowed" : "hover:bg-error-200"
            }`,
        underline: `text-grey-900 underline px-3 py-2 whitespace-nowrap ${disabled ? "!opacity-50 cursor-not-allowed" : "hover:text-grey-700"
            }`,
    };

    const styles = `${baseStyles} ${variants[variant]} ${className}`;

    return (
        <button
            className={styles}
            onClick={!disabled ? onClick : undefined}
            disabled={disabled}
            {...rest}
        >
            {children}
        </button>
    );
};

export default Button;